import { AppConfig } from './app-config.interface';

export const environment = {
  production: false,
  dynatraceScriptUrl: 
    'https://js-cdn.dynatrace.com/jstag/188d956ec0f/bf28435six/708444badc49198a_complete.js',
};

export const appConfig: AppConfig = {
  production: false,
  apiIssuer: "https://carbon-credit-portal-cer.b3.com.br/issuer/api/carbon-credit-issuer/v1",
  apiOperations: "https://carbon-credit-portal-cer.b3.com.br/operations/api/carbon-credit-operation/v1",
  apiCustody: "https://carbon-credit-portal-cer.b3.com.br/custody/api/carbon-credit-custody/v1",
  nomeUrl: "https://nomehom.cetip.net.br/menu/ctp/TelaPrincipalCetip21",
  url_base: "https://auth4b3-pf-cert.b3.com.br",
  redirect_url: "https://creditocarbono-cer.b3.com.br",
  client_id: "CREDCARB_CLIENT",
  response_type: "code",
  grant_type: "authorization_code",
  policy: "01AUTHSIMPLE",
  code_challenge_method: "S256",
  acxPlataformRedirectUrl: "https://trade.uat.br.acx.net",
  urlSuporteB3: "https://clientes.b3.com.br/w/cadastro?utm_source=B3_MVP&utm_medium=HM_EM&utm_campaign=card",
};
